import ClientInvoiceAssignmentSearchParams from '../Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceAssignmentSearchParams';
import ClientInvoiceLineItemSearchParams from '../Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceLineItemSearchParams';

export default class ApplyPaymentItem {
  constructor() {
    this.AllItemsInTheSearchAreSelected = false;
    this.NumberOfItemsSelected = 0;
    this.LineItemIds = [];
    this.ClientInvoiceIds = [];
    this.ClientInvoiceId = 0;
    this.ClientPaymentId = 0;
    this.InvoiceType = '';
    this.LineItemSearchParams = new ClientInvoiceLineItemSearchParams();
    this.AssignmentSearchParams = new ClientInvoiceAssignmentSearchParams();
  }
}
